import React, { useState, useEffect } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
// import { Card, CardContent, Button, Modal } from '@mui/material';
import { Card, CardContent, Modal, Button } from '@material-ui/core';
import { useAuth } from '../../AuthContext';
import { tokenIsExpired } from '../../authUtils';
import './Home.css'; // Import your CSS file
import CopyrightIcon from '@mui/icons-material/Copyright';
import PaidIcon from '@mui/icons-material/Paid';
import ReceiptIcon from '@mui/icons-material/Receipt';
import { fetchData, deleteData, activateData, SyncData, updateData, RentCollectionData } from '../../apiService';
import { Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import PersonIcon from '@mui/icons-material/Person';
import BillPrint from '../pages/RentCollection/Bill';
import ReactDOM from 'react-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CircularProgress from '@mui/material/CircularProgress';


const Home = () => {
  const { isAuthenticated, companyId, userId, permissions, token, logout, roleName } = useAuth();
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);

  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }
    fetchtableData();
    setLoading(true);
  }, [isAuthenticated, companyId, userId, token, logout]);

  useEffect(() => {
    handleToDateChange();
  }, []);

  // const fetchtableData = async () => {
  //   // fetchData('CustomerApi', `/${companyId}`, token)
  //   RentCollectionData('RentCollectionsApi', toDate, companyId, token)
  //     .then((response) => {
  //       if (response.responseCode == '1111') {
  //         console.log(response);
  //         setData(response.response_data);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching Customer Details:', error);
  //     });
  // };

  const fetchtableData = async () => {
    try {
      setLoading(true); // Show loading screen
      const response = await RentCollectionData('RentCollectionsApi', toDate, companyId, token);

      if (response.responseCode === '1111') {
        console.log(response);
        setData(response.response_data);
      } else {
        console.error('Unexpected response code:', response.responseCode);
      }
    } catch (error) {
      console.error('Error fetching Customer Details:', error);
    } finally {
      setLoading(false); // Hide loading screen
    }
  };

  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchInput, setShowSearchInput] = useState(false);
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const toggleSearchInput = () => {
    setShowSearchInput(!showSearchInput);
  };

  const filteredDatas = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }


  const [filteredData, setFilteredData] = useState([]);

  const handleToDateChange = async (event) => {
    const selectedDate = event?.target?.value;
    if (!selectedDate) return;
    setData([]);
    setToDate(selectedDate);
    try {
      const response = await RentCollectionData('RentCollectionsApi', selectedDate, companyId, token);
      if (response.responseCode === '1111') {
        if (response.response_data && response.response_data.length > 0) {
          console.log(response);
          setData(response.response_data);
        } else {
          console.warn('No data available for the selected date.');
          setData([]); // or handle it appropriately
        }
      } else {
        console.error('Failed to fetch data:', response.responseMessage || 'Unknown error');
      }
    } catch (error) {
      console.error('Error fetching Customer Details:', error);
    }
  };



  const handlePrint = async () => {
    try {
      // Fetch data
      setIsLoading(true);
      const customerId = InvoicedRooms.CustomerId;
      const response = await fetchData('RentCollectionsApi', `/RentCollectionPrint/${customerId}/${userId}/${toDate}`, token);
      const labelData = response.response_data;
      // Array.isArray(response.response_data) ? response.response_data : [response.response_data];
      console.log(response);
      console.log(labelData);
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');


      ReactDOM.render(
        <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,

        iframeDocument.body
      );

      iframeDocument.write('</body></html>');
      iframeDocument.close();

      iframe.contentWindow.print();
      await handleToDateChange({ target: { value: toDate } });
      try {
        await SyncData('RentCollectionsApi', `${customerId}`, token);
      } catch (updateError) {
        console.error('Error updating record:', updateError);
      }
    } catch (error) {
      console.error('Error printing Estimate:', error);
    }
  };

  const [open, setOpen] = useState(false);
  const [InvoicedRooms, setInvoicedRooms] = useState([]);

  const handleOpen = async (customerId) => {
    setOpen(true);
    try {
      const response = await fetchData('ReportApi', `/CustomerRoomDetails/${customerId}`, token);

      if (response.responseCode === '1111') {
        setInvoicedRooms(response.response_data);
      } else {
        // Handle unexpected response codes
        console.error('Unexpected response code:', response.responseCode);
      }

      console.log(response);
    } catch (error) {
      console.error('Error fetching item details:', error);

      // Handle specific HTTP errors if needed
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
  };


  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const handleInvoiceClick = () => {
    setConfirmationOpen(true);
  };

  const handleConfirmInvoice = () => {
    setConfirmationOpen(false);
    handlePrint();
  };

  const handleCancel = () => {
    setConfirmationOpen(false);
  };

  // Vacating 
  const [vacateconfirmationOpen, setVacateConfirmationOpen] = useState(false);
  const handleVacateClick = () => {
    setVacateConfirmationOpen(true);
  };

  const handleConfirmVacate = () => {
    setVacateConfirmationOpen(false);
    VacatingSubmit();
  };

  const handleVacateCancel = () => {
    setVacateConfirmationOpen(false);
  };

  const CustomerRelationId = InvoicedRooms.CustomerRelationId;

  const VacatingSubmit = async () => {
    setOpen(false);
    setIsLoading(true);
    const updatedFormData = {
      ID: InvoicedRooms.CustomerRelationId,
      RoomId: InvoicedRooms.RoomId,
      CustomerId: InvoicedRooms.CustomerId,
      CreatedDate: InvoicedRooms.Createddate,
      BillGenerateDate: InvoicedRooms.Rentdate,
      CustomerRentAmount: InvoicedRooms.RentAmount,
      CreatedBy: InvoicedRooms.UserId,
      UpdatedBy: userId,
      companyId: companyId,
    };


    try {
      await updateData('ReportApi', `${CustomerRelationId}`, updatedFormData, token);
      //setSuccessMessages("Vacated successfully!");
      //setErrorMessages("");
      setTimeout(() => {
        // setSuccessMessages("");
        window.location.reload();
      }, 3000); // 3 seconds
    } catch (error) {
      console.error('Error updating record:', error);
      setIsLoading(false);
    }
  };

  return (
    <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto' }}>
      <style>
        {`
        /* Hide scrollbar for Chrome, Safari, and Opera */
        .container::-webkit-scrollbar {
          width: 0.1em;
        }

        .container::-webkit-scrollbar-track {
          background: rgba(255,255,255,0);
        }

        .container::-webkit-scrollbar-thumb {
          background-color: rgba(255,255,255,0);
          border-radius: 4px;
        }
      `}
      </style>
      <div className="flex flex-wrap justify-between">
        {loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}>
            <div>
              <CircularProgress style={{ color: 'white' }} />
              <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
            </div>
          </div>
        )}
        <Card className="w-full sm:w-4/4 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)', marginTop: '5px' }}>
          <CardContent>
            <div className="flex justify-between items-center">
              <h4 className="block uppercase text-lg font-semibold mb-4 linkcolor animated-title" style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}></h4>

              <div
                className="flex space-x-2 button-container"
                style={{
                  display: 'flex',
                  flexDirection: 'row', // Default for larger screens
                  flexWrap: 'wrap',
                }}
              >
                {/* className="animated-icon"  */}
                <Button
                  variant="contained"
                  startIcon={<PaidIcon />}
                  style={{
                    marginRight: '8px',
                    // background: 'linear-gradient(to right, darkolivegreen, olive)',
                    background: 'linear-gradient(to right, brown, slategray)',
                    borderRadius: '50px',
                    padding: '10px 20px',
                    color: 'white',
                    fontWeight: 'bolder',
                    textTransform: 'none',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    height: '30px',
                    width: '185px',
                    order: 1, // This will be the first button on phone view
                  }}
                  component={Link}
                  to="/RentedCustomerIndex"
                >
                  Generate Invoice
                </Button>

                <Button
                  variant="contained"
                  startIcon={<ReceiptIcon />}
                  style={{
                    marginRight: '8px',
                    // background: 'linear-gradient(to right, darkslategray, slategray)',
                    background: 'linear-gradient(to right, darkgreen, slategray)',
                    borderRadius: '50px',
                    padding: '10px 20px',
                    color: 'white',
                    fontWeight: 'bolder',
                    textTransform: 'none',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                    height: '30px',
                    width: '100px',
                    order: 2, // This will be the second button on phone view
                  }}
                  component={Link}
                  to="/ReceiptCreate"
                >
                  Receipt
                </Button>

                <Button
                  variant="contained"
                  startIcon={<PersonIcon />}
                  style={{
                    marginRight: '8px',
                    // background: 'linear-gradient(to right, brown, slategray)',
                    background: 'linear-gradient(to right, orange, slategray)',
                    borderRadius: '50px',
                    padding: '10px 20px',
                    color: 'white',
                    fontWeight: 'bolder',
                    textTransform: 'none',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                    height: '30px',
                    width: '110px',
                    order: 3, // This will be the third button on phone view
                    marginTop: '5px'

                  }}
                  component={Link}
                  to="/CustomerCreate"
                >
                  Customer
                </Button>

                <Button
                  variant="contained"
                  startIcon={<MeetingRoomIcon />}
                  style={{
                    marginRight: '8px',
                    // background: 'linear-gradient(to right, darkblue, slategray)',
                    background: 'linear-gradient(to right, salmon, slategray)',
                    borderRadius: '50px',
                    padding: '10px 20px',
                    color: 'white',
                    fontWeight: 'bolder',
                    textTransform: 'none',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                    height: '30px',
                    width: '110px',
                    order: 4, // This will be the fourth button on phone view
                    marginTop: '5px'
                  }}
                  component={Link}
                  to="/RoomCreate"
                >
                  Rooms
                </Button>
              </div>

            </div>
          </CardContent>
        </Card>

      </div>
      <Card className="w-full sm:w-4/4 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)', marginTop: '5px' }}>
        <CardContent>

          <div>
            <h6 style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'darkslategray', fontWeight: 'bolder' }}>GENERATE INVOICE</h6>
          </div>

          <div className='flex flex-col mb-2 md:mb-0 md:mr-4 justify-end ml-auto' style={{ width: '200px' }}>
            <input
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              type="date"
              id="todayDate"
              name="todayDate"
              value={toDate}
              onChange={handleToDateChange}
            />
          </div>

          <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
            {data && data.map((item) => (
              <Card key={item.Id} className="customCard" style={{
                marginBottom: '10px',
                // background: 'linear-gradient(to right, #96CEB4,#96CEB4)',
                // backgroundColor : '#754043',
                backgroundColor: '#4F4557',
                color: 'white',
                marginLeft: '30px',
                height: '70px',
                boxSizing: 'border-box',
                width: '250px',
                cursor: 'pointer'
              }}
                onClick={() => handleOpen(item.CustomerId)}
              >
                <CardContent
                  style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    alignItems: 'left',
                    padding: '10px',
                    boxSizing: 'border-box'
                  }}>
                  <div style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textAlign: 'left'
                  }}>
                    {item.CustomerName}
                  </div>
                  <div style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textAlign: 'left'
                  }}>
                    {item.RoomName}
                  </div>
                  <div style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textAlign: 'left'
                  }}>
                    {item.RoomRent}
                  </div>

                </CardContent>
              </Card>

            ))}
          </div>
        </CardContent>

        {/* Generate Invoice  */}
        <Modal open={open} onClose={handleClose}>
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '80%',
            maxWidth: '600px',
            backgroundColor: 'white',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
          }}>
            <h5 style={{ fontFamily: 'time news roman', fontWeight: 'bolder' }}>DETAILS</h5>
            <div style={{ padding: '10px 0' }}>
              {InvoicedRooms ? (
                <div>
                  <p style={{ margin: '10px 0' }}>
                    <strong style={{ marginRight: '10px' }}>Customer:</strong>
                    <strong style={{ color: 'darkmagenta' }}>{InvoicedRooms.Customer}</strong>
                  </p>
                  <p style={{ margin: '10px 0' }}>
                    <strong style={{ marginRight: '10px' }}>Room:</strong>
                    <strong style={{ color: 'darkmagenta' }}>{InvoicedRooms.RoomName}</strong>
                  </p>
                  <p style={{ margin: '10px 0' }}>
                    <strong style={{ marginRight: '10px' }}>Rent Amount:</strong>
                    <strong style={{ color: 'darkmagenta' }}>{InvoicedRooms.RentAmount}</strong>
                  </p>
                  <p style={{ margin: '10px 0' }}>
                    <strong style={{ marginRight: '10px' }}>Joining Date:</strong>
                    <strong style={{ color: 'darkmagenta' }}>{formatDate(InvoicedRooms.Joiningdate)}</strong>
                  </p>
                  <p style={{ margin: '10px 0' }}>
                    <strong style={{ marginRight: '10px' }}>Leaving Date:</strong>
                    {InvoicedRooms.Leavingdate ? (
                      <strong style={{ color: 'darkmagenta' }}>{formatDate(InvoicedRooms.Leavingdate)}</strong>
                    ) : (
                      <strong style={{ color: 'darkmagenta' }}>Not Updated The Date</strong>
                    )}
                  </p>

                </div>
              ) : (
                <p>Loading...</p>
              )}
            </div>

            <Button onClick={handleInvoiceClick} disabled={isLoading} style={{ backgroundColor: 'brown', color: 'white', marginLeft: '5px' }}>
              {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>INVOICE</b>}
            </Button>
            <Button onClick={handleVacateClick} disabled={isLoading} style={{ backgroundColor: 'teal', color: 'white', marginLeft: '5px' }}>
              {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>VACATE</b>}
            </Button>
            {/* Invoice  Confirmation Modal */}
            <Modal open={confirmationOpen} onClose={handleCancel}>
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '80%',
                maxWidth: '400px',
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
              }}>
                <h5 style={{ fontFamily: 'Times New Roman', fontWeight: 'bolder', textAlign: 'center' }}>Confirm Generating Invoice</h5>
                <p style={{ textAlign: 'center', marginBottom: '20px' }}>Are you sure you want to Generate Rent Invoice?</p>
                <div style={{ textAlign: 'center' }}>
                  <Button onClick={handleConfirmInvoice} disabled={isLoading} style={{ backgroundColor: 'brown', color: 'white', marginRight: '10px' }}>
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>YES</b>}
                  </Button>
                  <Button onClick={handleCancel} disabled={isLoading} variant="contained" color="primary">
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>NO</b>}
                  </Button>
                </div>
              </div>
            </Modal>
            <Button onClick={handleClose} variant="contained" color="primary" style={{ marginLeft: '5px' }}>Close</Button>

            {/* Vacate Confirmation Modal */}
            <Modal open={vacateconfirmationOpen} onClose={handleVacateCancel}>
              <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '80%',
                maxWidth: '400px',
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
              }}>
                <h5 style={{ fontFamily: 'Times New Roman', fontWeight: 'bolder', textAlign: 'center' }}>Confirm Vacating</h5>
                <p style={{ textAlign: 'center', marginBottom: '20px' }}>Are you sure you want to vacate this room?</p>
                <div style={{ textAlign: 'center' }}>
                  <Button onClick={handleConfirmVacate} disabled={isLoading} style={{ backgroundColor: 'brown', color: 'white', marginRight: '10px' }}>
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>YES</b>}
                  </Button>
                  <Button onClick={handleVacateCancel} variant="contained" color="primary" disabled={isLoading}>
                    {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>NO</b>}
                  </Button>
                </div>
              </div>
            </Modal>


          </div>
        </Modal>
      </Card>
      <div className="watermark">
        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
      </div>
    </div>
  );

};

export default Home;

